import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="clear-field"
export default class extends Controller {
  static targets = ["field"]

  connect() {
  }

  clear() {
    this.fieldTarget.value = ""
    if (this.fieldTarget.tomselect) {
      this.fieldTarget.tomselect.clear();
    }
  }

}
